module.exports = __webpack_public_path__ + "img/cadeira_vermelha.cf41c254.png";